module.exports = require('./lib/scripts/Joyride.js');



//////////////////
// WEBPACK FOOTER
// ./~/react-joyride/index.js
// module id = 1980
// module chunks = 0 1 3